import LazyLoad from 'vanilla-lazyload';
import missingImage from '@/assets/missing-image_640X480.png';
const imageLazyLoad = new LazyLoad({
	elements_selector: 'img[data-src]',
});

let totalCount = 0;
let currentCount = 0;


export default {
	bind: (element: HTMLElement, obj: any) => {
		totalCount++;
		setTimeout(() => {
			const dataSrc = element.getAttribute('data-src');

			// Set default image if not exists
			if (!dataSrc) {
				element.setAttribute('data-src', missingImage);
			}
			currentCount++;
			// Update only once
			if (totalCount === currentCount) {
				imageLazyLoad.update();
			}
		}, 0);
	},
	update(element: HTMLElement) {
		const isProcessed = (element.getAttribute('data-was-processed'));

		if (isProcessed) {
			const src = element.getAttribute('src');
			const dataSrc = element.getAttribute('data-src');

			if (src !== dataSrc && dataSrc != null) {
				element.setAttribute('src', dataSrc);
			}
		}
	},
};
